import { UserPrinterDocument } from '../../user-admin';

export interface PrintTemplate {
  template: string;
  model: any;
  printer: UserPrinterDocument;
  copies?: number;
}
